export default {"src":"/_next/static/media/global-work.c9887bf1.svg","height":356,"width":452,"blurWidth":0,"blurHeight":0};